import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { TextArea } from "@/components/TextArea/TextArea";

interface SubjectLinePatternsSectionProps {
	value: string;
	onChange: (value: string) => void;
}

export const SubjectLinePatternsSection: FunctionComponent<SubjectLinePatternsSectionProps> = ({
	value,
	onChange,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`copywritingSettings.subjectLinePatterns.${key}`);

	return (
		<div className="flex flex-col gap-4">
			<p className="text-sm text-text-meta">{ts("description")}</p>

			<TextArea
				handleChange={(e) => onChange(e.target.value)}
				name="subjectLinePatterns"
				placeholder={ts("placeholder")}
				showError={false}
				value={value}
			/>
		</div>
	);
};
